var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CompanyHeader',{attrs:{"img_header":_vm.header_image,"header":"ตั้งค่าข้อมูลบริษัท","link_back":"managewebsite"}}),_c('MenuCompany'),_c('Branch_information')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }